import { makeStylesheetLink } from "../stylesheet";

export class ContinueAsGuest extends HTMLElement {
	shadow: ShadowRoot;
	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button type="button" className="gct-btn-lg gct-btn-secondary gct-w100">Checkout as Guest</button> as HTMLButtonElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			this.button,
			makeStylesheetLink()
		);
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick.bind(this));
		updateDisplay();
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick.bind(this));
	}

}

async function onClick(this: ContinueAsGuest) {
	const authSection = document.getElementById("auth-section");
	const checkoutSection = document.getElementById("checkout-section");

	if (authSection && checkoutSection) {
		authSection.style.display = "none";
		checkoutSection.style.display = "flex";

		localStorage.setItem("checkoutAsGuest", "true");
	}
}


function updateDisplay() {
	const checkoutAsGuest = localStorage.getItem("checkoutAsGuest");

	const authSection = document.getElementById("auth-section");
	const checkoutSection = document.getElementById("checkout-section");

	if (checkoutAsGuest === "true" && authSection && checkoutSection) {
		authSection.style.display = "none";
		checkoutSection.style.display = "flex";
	}
}
